import useAxios from "../../hooks/useAxios";

const useSpectateCosService = () => {
  const axiosGetAllCos = useAxios();

  const getCosFromAppId = async (posId) => {
    await axiosGetAllCos.fetchData({
      url: `/approver/cos/${posId}`,
      method: "GET",
    });
  };

  return {
    // list
    getCosFromAppId,
    cosLoading: axiosGetAllCos.loading,
    cosResponse: axiosGetAllCos.response,
  };
};

export default useSpectateCosService;
